export interface IHasCacheData {
    cache_last_update: number;
}
